var body = function body(_ref, course, bucket) {
  var encses = _ref.encses,
      sessionId = _ref.sessionId;
  if (!encses || !sessionId) throw new TypeError('encses & sessionId are required');
  return 'action=viewGradeInfoDialog&fromHttp=yes&ishttp=true' + "&corNumId=".concat(course, "&bucket=").concat(bucket) + "&sessionid=".concat(sessionId, "&encses=").concat(encses);
};

module.exports = function (axios, skywardURL) {
  return function (auth, course, bucket) {
    if (!axios || !skywardURL) throw new TypeError('axios & skywardURL are required');
    return axios({
      url: '../httploader.p?file=sfgradebook001.w',
      baseURL: skywardURL,
      method: 'post',
      data: body(auth, course, bucket)
    });
  };
};